import PageLoader from '../common/pageLoader/PageLoader';
import TextInput from '../UIComponent/TextInput';
import ValidationText from '../../utils/validation/ValidationText';

function EditChapterManagerEmails(props) {

    return (
        <div className="w-full flex justify-center">
            {props.isLoading ? < PageLoader /> :
                <table className="w-full bg-white shadow-lg rounded-sm border border-slate-200 ">
                    {/* Table header */}
                    <thead className="table-bg text-xs font-semibold capitalize text-[#757575] border-t border-b border-slate-200 ">
                        <tr>
                            <th className="px-3 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white border ">
                                <div className="font-bold tble-th-txt text-left">
                                    Chapter
                                </div>
                            </th>
                            <th className="px-3 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white border  ">
                                <div className="font-bold tble-th-txt text-center flex">
                                    Chapter Email
                                </div>
                            </th>
                            <th className="px-3 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white border ">
                                <div className="font-bold tble-th-txt text-center flex">
                                    CC Emails
                                </div>
                            </th>
                            <th className="px-3 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white border ">
                                <div className="font-bold tble-th-txt text-left flex items-center justify-center">
                                    Actions
                                </div>
                            </th>
                        </tr>
                    </thead>
                    {/* Table body */}
                    <tbody className="text-sm custom-tbody">
                        {(
                            props.chapterManagerEmail.length === 0) ? (
                            <tr className="">
                                <td
                                    className="w-full text-lg text-center py-4 text-[#757575] "
                                    colSpan="100%"
                                >
                                    No Records Found
                                </td>
                            </tr>
                        ) : (
                            props.chapterManagerEmail.map((chapter, key) => (
                                <tr key={key}>
                                    <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] border ">
                                        <div className="flex flex-col">
                                            <div className="current-text">{chapter.chapterName}</div>
                                        </div>
                                    </td>
                                    <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] border ">
                                        <div className="flex flex-col">
                                            {props &&
                                                props.addEditChapter === true &&
                                                props.selectChapterId === chapter.chapterManagerEmailId ? (
                                                <div key={key} className="flex flex-col relative">
                                                    <div
                                                        className={`edit-field input-height-set`}
                                                    >
                                                        <TextInput
                                                            placeholder=""
                                                            type="email"
                                                            name="chapterManagerEmail"
                                                            value={props.chapterDetails.chapterManagerEmail}
                                                            handleChange={props.handleChange}
                                                            identity="chapterManagerEmail"
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="absolute bottom-[-22px]">
                                                        <ValidationText
                                                            error={props.validState?.error?.chapterManagerEmail}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="current-text">
                                                    {chapter.chapterManagerEmail}
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] border ">
                                        <div className="flex flex-col">
                                            {props &&
                                                props.addEditChapter === true &&
                                                props.selectChapterId === chapter.chapterManagerEmailId ? (
                                                <div key={key} className="flex flex-col relative">
                                                    <div
                                                        className={`edit-field input-height-set d-flex`}
                                                    >
                                                        
                                                        <TextInput
                                                            placeholder=""
                                                            type="email"
                                                            name="ccEmails"
                                                            value={props.chapterDetails.ccEmails}
                                                            handleChange={props.handleChange}
                                                            identity="ccEmails"
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="absolute bottom-[-22px]">
                                                        <ValidationText
                                                            error={props.validState.error.ccEmails}
                                                        />
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="current-text">
                                                    {chapter.ccEmails}
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className="px-3 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt pointer text-[#757575] border ">
                                        {props &&
                                            props.addEditChapter === true &&
                                            props.selectChapterId === chapter.chapterManagerEmailId ? (
                                            <div className="flex items-center justify-center edit-field">
                                                <button
                                                    className="action-btn mr-4 flex items-center"
                                                    aria-controls="add-edit-modal"
                                                    disabled={props.isSaveLoading}
                                                    onClick={() => {
                                                        props.updateChapterManagerEmail();
                                                    }}
                                                >
                                                    <p className="ml-2 tool-tip-txt text-[#c00000] underline cursor-pointer">
                                                        Save
                                                    </p>
                                                </button>
                                                <button
                                                    className="action-btn mr-4 flex items-center"
                                                    aria-controls="add-edit-modal"
                                                    onClick={() => {
                                                        props.cancelAddEditChapter();
                                                    }}
                                                >
                                                    <img
                                                        src="/cancel-icon.png"
                                                        className="w-[22px] mx-auto my-0"
                                                        alt=""
                                                    ></img>
                                                </button>
                                            </div>
                                        ) : (
                                            <div className="flex items-center justify-center">
                                                <button
                                                    className="action-btn mr-4 flex items-center"
                                                    aria-controls="add-edit-modal"
                                                    onClick={() => {
                                                        props.startEditing(chapter);
                                                    }}
                                                >
                                                    <p className="ml-2 tool-tip-txt underline text-[#757575]">
                                                        Edit
                                                    </p>
                                                </button>
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}

                    </tbody>
                </table>
            }
        </div>
    )
}

export default EditChapterManagerEmails